import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionDetailsDataExperimentsQuery,
	PetitionDetailsDataExperimentsQueryVariables,
} from './experiments.graphql';
import { PetitionDetailsDataExperiments } from './experiments.graphql';

export async function fetchPetitionDetailsExperiments(
	utilityContext: UtilityContext,
): Promise<PetitionDetailsDataExperimentsQuery['experiments']> {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<PetitionDetailsDataExperimentsQuery, PetitionDetailsDataExperimentsQueryVariables>({
		query: PetitionDetailsDataExperiments,
		rejectOnError: true,
	});
	return data.experiments;
}
